import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { DEFAULT_LOCALE, LANGUAGE_QUERY_PARAM } from 'utils/i18n';
import createLocation from 'utils/createLocation';
import queryparse from 'tricks/string/queryparse';
import { formatLanguageCode } from 'i18n/options';
function getStoredLanguage() {
  var rawValue = localStorage.getItem('language');
  if (!rawValue) {
    return undefined;
  }
  try {
    var parsedValue = JSON.parse(rawValue);
    if (typeof parsedValue !== 'string') {
      return undefined;
    }
    return formatLanguageCode(parsedValue) || undefined;
  } catch (_unused) {
    return undefined;
  }
}
var useUserLocale = function useUserLocale() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$languageQueryPar = _ref.languageQueryParam,
    languageQueryParam = _ref$languageQueryPar === void 0 ? LANGUAGE_QUERY_PARAM : _ref$languageQueryPar;
  var location = useLocation();
  var navigate = useNavigate();
  var _ref2 = queryparse(location.search),
    langParam = _ref2[languageQueryParam];
  var fallbackLocale = 'en-GB';
  var defaultLocale = formatLanguageCode(DEFAULT_LOCALE) || fallbackLocale;
  var lang = langParam ? formatLanguageCode(langParam) : null;
  var _useState = useState(lang || getStoredLanguage() || defaultLocale),
    _useState2 = _slicedToArray(_useState, 2),
    locale = _useState2[0],
    setLocale = _useState2[1];
  useEffect(function () {
    setLocale(lang || getStoredLanguage() || defaultLocale);
  }, [defaultLocale, lang]);
  var changeLocale = function changeLocale(newLocale) {
    navigate(createLocation(location, _defineProperty({}, languageQueryParam, newLocale)), {
      replace: true
    });
  };
  return {
    locale: locale,
    changeLocale: changeLocale
  };
};
export default useUserLocale;